import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'input';
const idGen = new IDGenerator('wm_text');

register('wm-text', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {
          const counter = idGen.nextUid();
            const leadingIconMarkup = `<button class="btn-leading-icon ng-hide" type="button" name="leadingiconclass"><i aria-hidden="true" class="leadingiconclass"></i></button>`;
            const trailingIconMarkup = `<button class="btn-trailing-icon ng-hide" type="button" name="trailingiconclass"><i aria-hidden="true" class="trailingiconclass"></i></button>`
            const supportingtextMArkup = `<p class="app-label help-block" name="showsupportingtext">${attrs.get('supportingtext') || ''}</p>`
          return `${leadingIconMarkup} <${tagName} class="form-control app-textbox"
                    focus-target
                    role="textbox" wmText #${counter}="wmText" ${getAttrMarkup(attrs)} /> ${trailingIconMarkup} ${supportingtextMArkup}`;
        },
        post: () => ``
    };
});

export default () => {};
